module.exports = __webpack_public_path__ + "static/media/TATAPOWER.264cd3fb.txt";